import styled from "styled-components";
import { NavIcon } from "../../../components/Navigation/style";
import { theme } from "../../design-system/theme";

/** V2 sidebar: icons stay black (labels still use accent when active). */
export const NavIconV2 = styled(NavIcon)`
  color: #000000;
  flex-shrink: 0;
  .MuiSvgIcon-root {
    color: #000000;
  }
`;

/**
 * V2 sub-nav popup – rendered in portal, positioned to the right of the trigger menu item.
 */
export const SubNavPopup = styled.div`
  position: fixed;
  z-index: 1000;
  background: ${theme.colors.background};
  min-width: 300px;
  width: max-content;
  max-width: min(420px, calc(100vw - 48px));
  border-radius: 0 ${theme.borderRadius.lg} ${theme.borderRadius.lg} 0;
  border: 1px solid ${theme.colors.border};
  box-shadow: 0 8px 24px rgba(14, 18, 29, 0.1);
  padding: ${theme.spacing.md} 0;
  max-height: min(72vh, 580px);
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;

  /* Sub-nav content – same styles as V1 sub-navlist but no positioning */
  .sub-navlist {
    position: static;
    list-style: none;
    margin: 0;
    padding: 0;
    min-width: 0;
  }
  .sub-navlist li {
    padding: 0 ${theme.spacing.lg} 0 ${theme.spacing.lg};
    position: relative;
    margin-bottom: 2px;
  }
  .sub-navlist li:last-child {
    margin-bottom: 0;
  }
  .sub-navlist li:last-child .nav-link {
    border-bottom: none;
  }
  .sub-navlist > li > .nav-link {
    padding: ${theme.spacing.sm} ${theme.spacing.lg} ${theme.spacing.sm} 36px;
    border-radius: ${theme.borderRadius.sm};
    margin: 0 ${theme.spacing.sm};
    border-bottom: none;
    white-space: nowrap;
    transition: background 0.15s ease;
  }
  .sub-navlist > li > .nav-link:hover {
    background: ${theme.colors.backgroundAlt};
  }
  .sub-navlist > li > .nav-link:before {
    content: "";
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${theme.colors.border};
    top: 50%;
    transform: translateY(-50%);
    left: 22px;
  }
  .sub-navlist > li > .nav-link.active:before {
    background: ${theme.colors.accent};
    box-shadow: 0 0 0 3px ${theme.colors.accentLight};
  }
  .sub-navlist > li > .nav-link.active > div {
    color: ${theme.colors.accent};
    font-weight: 600;
  }
  .sub-navlist > li > .nav-link > div {
    font-size: ${theme.typography.fontSize.base};
    letter-spacing: 0.01em;
  }
`;
